import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import DoctorsList from "./pages/DoctorsList";
import Signup from "./pages/SignUp";
import Login from "./pages/Login";
import ProtectedRoute from "./pages/ProtectedRoute";
import DoctorProfile from "./pages/DoctorProfile";
import UserProfile from "./pages/UserProfile";
import UserNotifications from "./pages/UserNotifications";
import OAuthSuccess from "./pages/OAuthSuccess";
import DoctorProtectedRoute from "./doctor/DoctorProtectedRoute";
import DoctorLayout from "./doctor/DoctorLayout";
import LoginRename from "./admin/LoginRename";
import Protectedadmin from "./admin/Protectedadmin";
import UserDashboard from "./pages/UserDashboard";
import AppointmentCalendar from "./pages/AppointmentCalender";
import BookAppointment from "./pages/BookAppointment";
import ScreeningApp from "./Screening_test/src/App";

import Sidebar from "./components/Sidebar";
import DocumentUpload from "./components/DocumentUpload";
import RecordsSummary from "./components/RecordsSummary";
import AdminLayout from "./admin/AdminLayout";
import ForgotPassword from "./pages/ForgotPassword";
import UserAppointments from "./components/UserAppointments";

function Layout() {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f0f9ff", color: "#1e293b", position: "relative" }}>
      <style>{`
        /* ── Layout responsive ── */
        .layout-main {
          flex: 1;
          margin-left: 256px;
          padding: 24px;
          overflow-y: auto;
          min-height: 100vh;
        }
        .layout-topbar {
          display: none;
          align-items: center;
          gap: 12px;
          position: sticky;
          top: 0;
          z-index: 100;
          background: rgba(240,249,255,0.95);
          backdrop-filter: blur(12px);
          border-bottom: 1px solid #bae6fd;
          padding: 12px 16px;
          margin: -24px -24px 20px -24px;
        }
        .layout-hamburger {
          background: none;
          border: none;
          cursor: pointer;
          padding: 6px;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          gap: 5px;
          transition: background 0.2s;
        }
        .layout-hamburger:hover { background: #e0f2fe; }
        .layout-hamburger span {
          display: block;
          width: 22px;
          height: 2.5px;
          background: #0284c7;
          border-radius: 2px;
          transition: all 0.3s ease;
        }
        .layout-hamburger.open span:nth-child(1) { transform: translateY(7.5px) rotate(45deg); }
        .layout-hamburger.open span:nth-child(2) { opacity: 0; transform: scaleX(0); }
        .layout-hamburger.open span:nth-child(3) { transform: translateY(-7.5px) rotate(-45deg); }
        @media (max-width: 768px) {
          .layout-main { margin-left: 0; padding: 24px 16px 16px; }
          .layout-topbar { display: flex; }
        }
      `}</style>

      {/* User Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main Content */}
      <div className="layout-main">

        {/* Mobile top bar */}
        <div className="layout-topbar">
          <button
            id="user-hamburger-btn"
            className={`layout-hamburger ${sidebarOpen ? "open" : ""}`}
            onClick={() => setSidebarOpen(prev => !prev)}
            aria-label="Toggle navigation menu"
          >
            <span /><span /><span />
          </button>
          <div style={{ fontWeight: 700, fontSize: "17px", color: "#0c4a6e", display: "flex", alignItems: "center", gap: "6px" }}>
            <span>💉</span> Health <span style={{ color: "#3b82f6" }}>Panel</span>
          </div>
        </div>

        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/doctors" element={<DoctorsList />} />
          <Route path="/upload" element={<DocumentUpload />} />
          <Route path="/appointments" element={<UserAppointments />} />
          <Route path="/notifications" element={<UserNotifications />} />
          <Route path="/records" element={<RecordsSummary />} />
          <Route path="/doctor/:id" element={<DoctorProfile />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/dashboard" element={<UserDashboard />} />
          <Route path="/calendar" element={<AppointmentCalendar />} />
          <Route path="/screening/*" element={<ScreeningApp />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {

  return (
    <>
      <Router>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Routes>
          {/* Auth Pages */}
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin/login" element={<LoginRename />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/oauth-success" element={<OAuthSuccess />} />
          <Route path="/book" element={<BookAppointment />} />  {/* ← ADD THIS */}

          {/* Protected App (WITH SIDEBAR) */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          />

          {/* Admin Login */}
          <Route path="/admin/login" element={<LoginRename />} />

          {/* Protected Admin Panel */}
          <Route
            path="/admin/*"
            element={
              <Protectedadmin>

                <AdminLayout />
              </Protectedadmin>
            }
          />

          {/* Doctor Portal */}
          <Route
            path="/doctor-portal/*"
            element={
              <DoctorProtectedRoute>
                <DoctorLayout />
              </DoctorProtectedRoute>
            }
          />

          {/* Admin */}
          <Route path="/admin/*" element={<AdminLayout />} />

        </Routes>
      </Router>
    </>
  );
}

export default App;